<template>

	<div class="content">
		<div class="container-fluid">
			<div class="row mb-2">
				<div class="col-md-12">
					<router-link class="btn btn-info" :to="{ name: 'kang-voucher-tambah-saldo' }">Tambah Saldo</router-link>
					<router-link class="btn btn-success" :to="{ name: 'kang-voucher-buatkan' }">Buatkan Voucher</router-link>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12">
					<nav class="navbar navbar-expand-lg">
						<div class="navbar-nav">
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 0}" :to="{ name: 'detail-kang-voucher' }" v-on:click.native="data.tabActive = 0">
							Voucher
							</router-link>
							
							<router-link class="nav-item nav-link" v-bind:class="{'active' : data.tabActive === 1}" :to="{ name: 'history-kang-voucher' }" v-on:click.native="data.tabActive = 1">
							History Saldo
							</router-link>
						</div>
					</nav>
				</div>
			</div>

			<transition name="slide-fade" mode="out-in"><router-view></router-view></transition>
			
		</div>
	</div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

export default {
  name: 'Beranda',
	components: { 

	}, 
	setup() {
		const data = reactive({
			tabActive: 0,
		})

		return {
			data,
			myGlobal
		}
	},
	mounted () {
		document.title = "Rincian Admin";
	}
}
</script>

<style scoped>
.edit-input {
	font-size: 20pt !important;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/admin/kang-voucher/detail.vue